import 'rxjs/Rx';
import {Observable} from 'rxjs';
import {Component, OnDestroy, OnInit} from '@angular/core';
import {AppStateService, LoggerService, ModalService, TakerAppState} from '../../hbs-services';

@Component({
    selector: 'poll-timer',
    moduleId: module.id,
    templateUrl: './pollTimer.component.html'
})
export class PollTimerComponent implements OnInit, OnDestroy {

    // set to negative to display 'time is out' message
    whenOutOfTime: number = null;
    time: string = '';
    // used to prevent showing popup more than one time
    showedPopup = false;

    private appStateSubscription: any = null;
    private timerSubscription: any = null;

    constructor(private appStateService: AppStateService,
                private logger: LoggerService,
                private modalService: ModalService) {
    }

    ngOnInit() {
        this.appStateSubscription = this.appStateService.subscribe((newState: TakerAppState) => {
            this.logger.log('PollTimerComponent: AppStorageState:', newState);

            this.whenOutOfTime = null;
            this.time = '';

            if (newState.state === 'q-edit' || newState.state === 'q-view') {
                if (this.showedPopup) {
                    this.whenOutOfTime = -1;
                } else {
                    const pollLocalStartTime: number = newState.getPollLocalStartTime();
                    if (pollLocalStartTime !== null) {
                        const pollResponse: any = newState.context.pollResponse;
                        if (pollResponse && pollResponse.record.timeLimit > 0) {
                            this.whenOutOfTime = pollLocalStartTime + pollResponse.record.timeLimit * 60 * 1000;
                        }
                    }
                }
            }

            this.setTimer();
        });

    }

    ngOnDestroy() {
        if (this.appStateSubscription) {
            this.appStateSubscription.unsubscribe();
        }
        if (this.timerSubscription) {
            this.timerSubscription.unsubscribe();
            this.timerSubscription = null;
        }
    }

    setTimer() {

        if (!this.timerSubscription && !this.showedPopup &&
            this.whenOutOfTime !== null && this.whenOutOfTime >= 0) {

            const timer = Observable.interval(1000);

            this.timerSubscription = timer.subscribe((t: number) => {

                const now = new Date().getTime();

                this.time = this.millisecToString(this.whenOutOfTime - now);

                if (this.whenOutOfTime === null || now >= this.whenOutOfTime) {

                    if (this.timerSubscription) {
                        this.timerSubscription.unsubscribe();
                        this.timerSubscription = null;
                    }

                    if (this.whenOutOfTime !== null) {
                        this.whenOutOfTime = -1;    // setting to negative to display 'time is out'
                        this.showedPopup = true;

                        this.modalService.showAlert({
                            'title': 'Please submit your poll!',
                            'text': 'Your submit time will be noted, so be prompt!',
                            'type': 'warning'
                        });

                    }

                }

            });
        }

    }

    /**
     *
     * @param millisec
     * @returns {string} format hh:mm:ss
     */
    millisecToString(millisec: number): string {
        const sec: number = Math.floor(millisec / 1000);
        const hour = String(Math.floor(sec / 3600));
        let minute = String(Math.floor(sec / 60));
        if (minute.length < 2) {
            minute = '0' + minute;
        }
        let second = String(sec % 60);
        if (second.length < 2) {
            second = '0' + second;
        }
        const str: string = hour + ':' + minute + ':' + second;
        return str;
    }


}
